import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PageLayout from './src/layouts/PageLayout';
import HomePage from './src/pages/HomePage';
import MeetUsPage from './src/pages/MeetUsPage';
import ProgramsPage from './src/pages/ProgramsPage';
import ContactPage from './src/pages/ContactPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route element={<PageLayout data-id="element-3" />} data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/meet-us" element={<MeetUsPage data-id="element-7" />} data-id="element-6" />
          <Route path="/programs" element={<ProgramsPage data-id="element-9" />} data-id="element-8" />
          <Route path="/contact" element={<ContactPage data-id="element-11" />} data-id="element-10" />
        </Route>
      </Routes>
    </BrowserRouter>;
}